import Amount from "@/models/Shared/Amount";

export default class SegregatedBalances {
    timestamp: number = 0;
    platformBalance: Amount = new Amount();
    platformAvailableBalance: Amount = new Amount();
    segregatedAccountBalance: Amount = new Amount();
    platformBalanceCustomer: Amount = new Amount();    
    platformAvailableBalanceCustomer: Amount = new Amount();
    platformBalanceInstitutional: Amount = new Amount();
    platformAvailableBalanceInstitutional: Amount = new Amount();
}